<template>
  <div class="flex flex-col gap-12 proxima_nova max-w-5xl mx-auto px-4 md:px-8 py-2 pb-28">
    <!-- Header Section -->
    <div class="flex flex-col gap-6 items-center">
      <div class="flex flex-col gap-1 items-center">
        <div class="h-[30px] w-[280px] bg_dark_6 hsk pulse" />
        <div class="h-[20px] w-[400px] bg_dark_6 hsk pulse" />
      </div>
      <div class="flex flex-col items-center">
        <!-- Tab Component Skeleton -->
        <div class="flex flex-row gap-2">
          <div class="h-[40px] w-[120px] bg_dark_6 hsk pulse rounded-lg" />
          <div class="h-[40px] w-[120px] bg_dark_6 hsk pulse rounded-lg" />
        </div>
      </div>
    </div>

    <!-- Plan & Users Section -->
    <div class="flex flex-col gap-6">
      <div class="flex flex-row justify-between">
        <div>
          <div class="h-[24px] w-[150px] bg_dark_6 hsk pulse" />
        </div>
        <div class="flex flex-row gap-2 items-center">
          <div class="h-[16px] w-[200px] bg_dark_6 hsk pulse" />
          <div class="h-[32px] w-[32px] bg_dark_6 rsk pulse" />
          <div class="h-[24px] w-[20px] bg_dark_6 hsk pulse mx-4" />
          <div class="h-[32px] w-[32px] bg_dark_6 rsk pulse" />
        </div>
      </div>

      <!-- Plan Cards -->
      <div class="flex flex-row gap-8 w-full">
        <div v-for="index in 2" :key="index" class="flex-1 flex flex-col gap-4 p-6 rounded-lg border border-gray-200">
          <div class="flex flex-col gap-2">
            <div class="h-[24px] w-[100px] bg_dark_6 hsk pulse" />
            <div class="h-[32px] w-[80px] bg_dark_6 hsk pulse" />
            <div class="h-[16px] w-[150px] bg_dark_6 hsk pulse" />
            <div class="h-[16px] w-[120px] bg_dark_6 hsk pulse" />
          </div>

          <!-- Features List -->
          <div class="flex flex-col gap-3 mt-4">
            <div v-for="featureIndex in 6" :key="featureIndex" class="flex flex-row gap-3 items-center">
              <div class="h-[16px] w-[16px] bg_dark_6 rsk pulse" />
              <div class="h-[16px] w-[200px] bg_dark_6 hsk pulse" />
            </div>
          </div>

          <!-- Action Button -->
          <div class="h-[40px] w-full bg_dark_6 hsk pulse rounded-lg mt-4" />
        </div>
      </div>

      <!-- Plan Comparison Toggle -->
      <div class="flex flex-row gap-2 items-center justify-center">
        <div class="h-[20px] w-[180px] bg_dark_6 hsk pulse" />
        <div class="h-[16px] w-[16px] bg_dark_6 hsk pulse" />
      </div>
    </div>

    <!-- What Are Credits Section -->
    <div class="flex flex-col gap-4">
      <div class="h-[24px] w-[200px] bg_dark_6 hsk pulse" />
      <div class="flex flex-col gap-4 p-6 rounded-lg border border-gray-200">
        <div class="h-[20px] w-[300px] bg_dark_6 hsk pulse" />
        <div class="h-[16px] w-full bg_dark_6 hsk pulse" />
        <div class="h-[16px] w-[80%] bg_dark_6 hsk pulse" />
        <div class="h-[16px] w-[60%] bg_dark_6 hsk pulse" />
      </div>
    </div>

    <!-- Credits Section -->
    <div class="flex flex-col gap-6">
      <div class="h-[24px] w-[100px] bg_dark_6 hsk pulse" />
      <div class="flex flex-col gap-4 p-6 rounded-lg border border-gray-200">
        <div class="h-[20px] w-[250px] bg_dark_6 hsk pulse" />
        <div class="h-[40px] w-full bg_dark_6 hsk pulse rounded-lg" />
        <div class="flex flex-row justify-between">
          <div class="h-[16px] w-[80px] bg_dark_6 hsk pulse" />
          <div class="h-[16px] w-[80px] bg_dark_6 hsk pulse" />
        </div>
      </div>
    </div>

    <!-- Trusted By Section -->
    <div class="flex flex-col gap-6 items-center">
      <div class="h-[24px] w-[350px] bg_dark_6 hsk pulse" />
      <div class="h-[60px] w-full bg_dark_6 hsk pulse" />
    </div>

    <!-- Customer Reviews Section -->
    <div class="flex flex-col gap-6 items-center">
      <div class="h-[24px] w-[250px] bg_dark_6 hsk pulse" />
      <div class="flex flex-row gap-6">
        <div v-for="index in 3" :key="index" class="flex flex-col gap-4 p-6 rounded-lg border border-gray-200 w-[300px]">
          <div class="flex flex-row gap-3 items-center">
            <div class="h-[40px] w-[40px] bg_dark_6 rsk pulse" />
            <div class="flex flex-col gap-1">
              <div class="h-[18px] w-[120px] bg_dark_6 hsk pulse" />
              <div class="h-[14px] w-[100px] bg_dark_6 hsk pulse" />
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <div class="h-[16px] w-full bg_dark_6 hsk pulse" />
            <div class="h-[16px] w-[90%] bg_dark_6 hsk pulse" />
            <div class="h-[16px] w-[80%] bg_dark_6 hsk pulse" />
          </div>
        </div>
      </div>
    </div>

    <!-- FAQ Section -->
    <div class="flex flex-col gap-6 w-full">
      <div class="h-[24px] w-[200px] bg_dark_6 hsk pulse text-center mx-auto" />
      <div class="flex flex-col gap-4">
        <div v-for="index in 4" :key="index" class="flex flex-col gap-2 p-4 rounded-lg border border-gray-200">
          <div class="h-[20px] w-[300px] bg_dark_6 hsk pulse" />
          <div class="h-[16px] w-full bg_dark_6 hsk pulse" />
          <div class="h-[16px] w-[80%] bg_dark_6 hsk pulse" />
        </div>
      </div>
    </div>

    <!-- Footer Section -->
    <div class="fixed left-[225px] w-[calc(100vw-225px)] bottom-0 z-10 h-[90px] bg-white border-t border-gray-200 flex flex-row justify-between items-center px-6">
      <div class="flex flex-col gap-2">
        <div class="h-[18px] w-[150px] bg_dark_6 hsk pulse" />
        <div class="h-[16px] w-[100px] bg_dark_6 hsk pulse" />
      </div>
      <div class="flex flex-row gap-4 items-center">
        <div class="h-[40px] w-[120px] bg_dark_6 hsk pulse rounded-lg" />
        <div class="h-[40px] w-[100px] bg_dark_6 hsk pulse rounded-lg" />
      </div>
    </div>
  </div>
</template>

<script setup>
// No props needed for this skeleton loader
</script>

<style scoped>
.bg_dark_6 {
  background-color: rgba(0, 0, 0, 0.06);
}

.hsk {
  border-radius: 4px;
}

.rsk {
  border-radius: 9999px;
}

.pulse {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>
